import {
  Callout,
  ComponentPreview,
  ComponentSource,
  InstallCommand,
  MdxA,
  MdxBlockquote,
  MdxCode,
  MdxEm,
  MdxH1,
  MdxH2,
  MdxH3,
  MdxH4,
  MdxHr,
  MdxImg,
  MdxLi,
  MdxOl,
  MdxP,
  MdxPre,
  MdxSpan,
  MdxStrong,
  MdxTable,
  MdxTbody,
  MdxTd,
  MdxTh,
  MdxThead,
  MdxTr,
  MdxUl,
  PropsTable,
  Step,
  Steps,
  Tab,
  Tabs,
  TypeTable,
} from "@/site/components/docs/mdx-components";

const components = {
  a: MdxA,
  blockquote: MdxBlockquote,
  code: MdxCode,
  em: MdxEm,
  h1: MdxH1,
  h2: MdxH2,
  h3: MdxH3,
  h4: MdxH4,
  hr: MdxHr,
  img: MdxImg,
  li: MdxLi,
  ol: MdxOl,
  p: MdxP,
  pre: MdxPre,
  span: MdxSpan,
  strong: MdxStrong,
  table: MdxTable,
  tbody: MdxTbody,
  td: MdxTd,
  th: MdxTh,
  thead: MdxThead,
  tr: MdxTr,
  ul: MdxUl,
  Callout,
  ComponentPreview,
  ComponentSource,
  InstallCommand,
  PropsTable,
  Step,
  Steps,
  Tab,
  Tabs,
  TypeTable,
};

export const useMDXComponents = () => components;
